var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"grey--text"},[_c('span',{staticStyle:{"font-family":"'Parisienne', cursive","text-shadow":"2px 2px 2px #aaa","font-size":"150%"}},[_vm._v(" Lost And Found ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }